export default __webpack_public_path__ + "static/media/foot-left-back.e3e8c23f.png";